export const MALWARE_SCAN_STATE = {
  CLEAN: 'clean',
  SCANNING: 'scanning',
  MALICIOUS: 'malicious',
  UNVERIFIED: 'unverified',
};

// The file service writes these exact strings to malwareScanStatus. Any other string is an
// unrecognised scan result, which the file service treats as blocked.
export const MALWARE_SCAN_STATUS_CLEAN = 'No threats found';
const STATUS_PENDING = 'pending';
const STATUS_MALICIOUS = 'Malicious';

// A missing status (undefined or null) counts as unverified, so the file stays blocked. The file
// service remains the authority and rejects blocked downloads itself.
export const getMalwareScanState = (malwareScanStatus) => {
  if (malwareScanStatus === MALWARE_SCAN_STATUS_CLEAN) {
    return MALWARE_SCAN_STATE.CLEAN;
  }
  if (malwareScanStatus === STATUS_PENDING) return MALWARE_SCAN_STATE.SCANNING;
  if (malwareScanStatus === STATUS_MALICIOUS) return MALWARE_SCAN_STATE.MALICIOUS;
  return MALWARE_SCAN_STATE.UNVERIFIED;
};

export const isMalwareScanFinal = (malwareScanState) =>
  malwareScanState === MALWARE_SCAN_STATE.CLEAN ||
  malwareScanState === MALWARE_SCAN_STATE.MALICIOUS;

// Notification keys of the createFile group in notificationDefaults.js
export const SCAN_NOTIFICATION_KEYS = {
  [MALWARE_SCAN_STATE.CLEAN]: 'success',
  [MALWARE_SCAN_STATE.SCANNING]: 'scanning',
  [MALWARE_SCAN_STATE.MALICIOUS]: 'malwareDetected',
  [MALWARE_SCAN_STATE.UNVERIFIED]: 'scanUnverified',
};
